<template>
  <TopNav></TopNav>
  <h1>Statistics Calculator</h1>
  <fieldset>
    <legend>Statistics Calculator</legend>
    <label for="numbersField">Numbers:</label>
    <textarea v-model="numbers" autofocus id="numbersField" rows="4">
    </textarea>
    <br>
    <input type="radio" id="sample" v-model="sampleOrPopulation" name="sample" value="sample"><label for="sample">sample</label><br>
    <input type="radio" id="population" v-model="sampleOrPopulation" name="population" value="population"><label for="population">population</label><br>
    <br>
    Count: <span class="blue">{{ count() }}</span>
    <br>
    Sum: <span class="blue">{{ sum() }}</span>
    <br>
    Largest: <span class="blue">{{ largest() }}</span>
    <br>
    Smallest: <span class="blue">{{ smallest() }}</span>
    <br>
    Range: <span class="blue">{{ range() }}</span>
    <br>
    Variance: <span class="blue">{{ variance() }}</span>
    <br>
    Median: <span class="blue">{{ median() }}</span>
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'


export default {
  name: "Statistics",
  data() {
    return {
      numbers: "10, 10",
      sampleOrPopulation: "population"
    }
  },
  components: {
    TopNav
  },
  methods: {
    getNumbersArray: function () {
      let numbersArray = this.numbers.match(/-?[0-9]+/g);
      return numbersArray.map(Number);
    },
    count: function () {
      let numbersArray = this.getNumbersArray();
      return numbersArray.length;
    },
    sum: function () {
      let numbersArray = this.getNumbersArray();
      return numbersArray.reduce((a, b) => a + b);
    },
    largest: function () {
      let numbersArray = this.getNumbersArray();
      return Math.max(...numbersArray);
    },
    smallest: function () {
      let numbersArray = this.getNumbersArray();
      return Math.min(...numbersArray);
    },
    range: function () {
      return this.largest() - this.smallest();
    },
    variance: function () {
      let numbersArray = this.getNumbersArray();
      let count = this.count()
      let mean = this.sum() / count;
      let summations = 0;
      numbersArray.forEach(element => {
        let distance = (element - mean);
        let squareOfDistance = Math.pow(distance, 2);
        summations += squareOfDistance;
      });
      let variance = 0;
      if (this.sampleOrPopulation === "sample") {
        variance = summations / (count - 1);
      } else {
        variance = summations / count;
      }
      return variance;
    },
    median: function() {
      let numbersArray = this.getNumbersArray();
      let mid = Math.floor(numbersArray.length / 2)
      let sortedNumbers = [...numbersArray].sort((a, b) => a - b);
      return sortedNumbers.length % 2 !== 0 ? sortedNumbers[mid] : (sortedNumbers[mid - 1] + sortedNumbers[mid]) / 2;
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  width: 110px;
}

textarea {
    vertical-align: top;
    width: 98%;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
